import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

export function Layout({ children }: { children: React.ReactNode }) {
  const { user, logout } = useAuth();
  const location = useLocation();

  const navItems = [
    { label: '账号管理', path: '/users' },
    { label: '门店管理', path: '/stores' },
    { label: '报告管理', path: '/reports' },
    { label: '数据统计', path: '/statistics' },
  ];

  return (
    <div className="min-h-screen flex flex-col">
      <header className="bg-indigo-600 text-white shadow">
        <div className="max-w-5xl mx-auto px-4 py-3 flex items-center justify-between">
          <h1 className="text-base sm:text-lg font-semibold">宠物报告管理后台</h1>
          {user && (
            <div className="flex items-center gap-3 text-sm">
              <span className="hidden sm:inline">{user.nickname || user.username}</span>
              <button
                onClick={logout}
                className="px-3 py-1.5 rounded-md bg-white/10 hover:bg-white/20 active:bg-white/30 transition"
              >
                退出
              </button>
            </div>
          )}
        </div>
        {user && (
          <nav className="max-w-5xl mx-auto px-4 pb-2 flex gap-4 text-sm">
            {navItems.map((item) => {
              const active = location.pathname.startsWith(item.path);
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`pb-1 border-b-2 transition ${
                    active
                      ? 'border-white text-white font-medium'
                      : 'border-transparent text-indigo-100 hover:text-white'
                  }`}
                >
                  {item.label}
                </Link>
              );
            })}
          </nav>
        )}
      </header>

      <main className="flex-1 px-4 py-4 sm:py-6">
        <div className="max-w-5xl mx-auto">{children}</div>
      </main>
    </div>
  );
}
